import React, { useRef } from 'react';
import Slider, { Settings } from 'react-slick';

import { getAdvancedSettings } from '../advancedSettings';
import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';

import type { SliderType } from './sliderConfigAggregator';
import classes from './PageBuilderHero.module.scss';

type PageBuilderSliderProps = SliderType;

/**
 * Return the PB Slider
 * @param props
 * @constructor
 */
export function PageBuilderSlider(props: PageBuilderSliderProps) {
    const sliderRef = useRef<Slider>(null);
    const hasMoreThanOneSlide = props.hasMoreThanOneSlide;

    const isHero = props.isHero;

    /**
     * Configure the styles requires for the Block
     */
    const advancedSettings = getAdvancedSettings<PageBuilderSliderProps>(props);

    const layoutStyles = {
        minHeight: props.minHeight,
    };

    const sliderClassNames = ['pageBuilderSliderGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        sliderClassNames.push(...props.cssClasses);
    }

    if (isHero) {
        sliderClassNames.push(classes.sliderWrapper);
    }

    /**
     * Gallery setting for slick slider
     */
    const settings: Settings = {
        accessibility: true,
        arrows: hasMoreThanOneSlide ? props.showArrows : false,
        autoplay: hasMoreThanOneSlide ? props.autoplay : false,
        autoplaySpeed: props.autoplaySpeed,
        className: isHero ? classes.heroSlider : undefined,
        dots: hasMoreThanOneSlide ? props.showDots : false,
        draggable: true,
        fade: props.fade,
        infinite: hasMoreThanOneSlide ? props.infinite : false,
        slidesToScroll: 1,
        slidesToShow: 1,
        speed: 500,
        pauseOnHover: true,
    };

    /**
     * Render the Row Block UI
     */
    return (
        <PageBuilderElementWrapper
            contentType={props.contentType}
            uniqueID={props.uniqueID}
            styles={{
                ...advancedSettings,
                ...layoutStyles,
            }}
            classNames={sliderClassNames}
        >
            <Slider ref={sliderRef} {...settings}>
                {props.children}
            </Slider>
        </PageBuilderElementWrapper>
    );
}
